import { IdeActionProvider, IdeStateProvider, useOldPlayground } from '@common/ide/state';
import { Entity } from '@common/types/Entity';
import { Private_Routes } from '@common/url';
import { WorkflowModeType } from '@prophecy/graphql-types/enums';
import { ExtractUrlPathVariables } from '@prophecy/interfaces/generic';
import { CanvasRootRootCls, FooterRootCls } from 'frontend/core/src/layout/config';
import { useParams, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { GemIDE } from '../../ide/Playground';

const IdeLayout = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr) auto;
  grid-column-gap: 0px;
  grid-row-gap: 0px;

  .${CanvasRootRootCls} {
    grid-area: 1 / 2 / 2 / 3;
  }
  .${FooterRootCls} {
    grid-area: 2 / 1 / 3 / 3;
  }
`;
export default function GemBuilder({ isAirflow }: { isAirflow: boolean }) {
  const params = useParams<ExtractUrlPathVariables<typeof Private_Routes.GemPlayground.url>>();
  const uid = decodeURIComponent(params.componentId as string);
  const category = decodeURIComponent(params.category as string);
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') as WorkflowModeType | undefined;
  const { state, actions, setActions } = useOldPlayground({ uid, entity: Entity.Gem });
  return (
    <IdeStateProvider value={state}>
      <IdeActionProvider value={{ setActions, actions }}>
        <IdeLayout>
          <GemIDE
            mode={mode}
            category={category}
            isAirflow={isAirflow}
            key={uid}
            uidOrRepositoryPath={uid}
            currentProjectId={''}
            custom={true}
          />
        </IdeLayout>
      </IdeActionProvider>
    </IdeStateProvider>
  );
}
